jQuery( function ( $ ) {
    'use strict';

    // pma_show_hide_search_form();

    pma_back_to_top_link();
    pma_handle_menu_click();

    jQuery('#top-feature-boxes .top-feature-box').matchHeight();
    jQuery('.team-member .wp-block-column').matchHeight();

    // Allow smooth scroll
    $('.page-scroller').on('click', function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $('html, body').animate({
            'scrollTop': $target.offset().top
        }, 1000, 'swing');
    });

});

function pma_handle_menu_click() {
    let dropdown_toggle_button = jQuery('button.navbar-toggler');
    let dropdown_toggle = jQuery('.dropdown-toggle, .dropdown-item');
    dropdown_toggle.on('click', function(event) {
        // If the mobile menu toggle is not visible, that means we are on a non-mobile version of the site.
        if( ! dropdown_toggle_button.is(":visible")) {
            return true;
        }
        if( ! jQuery(this).hasClass('expanded') ) {
            event.preventDefault();
            jQuery(this).addClass('expanded');
        }
    });
}
function pma_show_hide_search_form() {
    let search_icon = jQuery( '#search-icon' );
    let search_icon_wrapper = search_icon.parent();
    let search_form = jQuery( '.search-form' );
    let search_field = jQuery('.search-field');

    search_icon.on( 'click', function() {
        search_icon_wrapper.toggleClass( 'expanded' );
        if( search_icon_wrapper.hasClass( 'expanded' ) ) {
            search_form.fadeIn();
            search_icon.removeClass( 'fa-search' ).addClass( 'fa-times' );
            search_field.focus();
        } else {
            search_form.fadeOut();
            search_icon.addClass( 'fa-search' ).removeClass( 'fa-times' );
        }
    } );
}
function pma_back_to_top_link() {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 50) {
            jQuery('#back-to-top').fadeIn();
        } else {
            jQuery('#back-to-top').fadeOut();
        }
    });
    // scroll body to 0px on click
    jQuery('#back-to-top').on('click touchstart', function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });
}

document.addEventListener("DOMContentLoaded", function(event) {

    // get all of the elements with the 'scroll' class.
    const scrollList = document.querySelectorAll(".scroll")

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {

                entry.target.classList.add("scrolled-in");
            }
        });
    }

    const options = {}

    const myObserver = new IntersectionObserver(callback, options)

    scrollList.forEach(scrollItem => {
        myObserver.observe(scrollItem)
    })

});

jQuery(window).on('resize scroll', function() {
    if (jQuery('.scroll').isInViewport()) {
        if( jQuery(this).hasClass('scroll-in-left') ) {
            jQuery(this).addClass('reveal-scroll-in-left');
        } else {
            jQuery(this).addClass('scrolled-in');
        }
        console.log('in view');
    } else {
        console.log('out of view');
    }
});

jQuery.fn.isInViewport = function() {
    var elementTop = jQuery(this).offset().top;
    var elementBottom = elementTop + jQuery(this).outerHeight();

    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};